angular.module('dashboard').factory('DashboardRepository',
    ['AprimaRestangular', 'storage',
        function (AprimaRestangular, storage) {
            'use strict';

            var patientDashboardFeatures = function() {
                return AprimaRestangular.get('patient').one('settings/dashboardsettings/').get();
            };
            var setDashboardFeatureList = function (value){
                return storage.set('dashboardFeatureList', value);
            };
            var getDashboardFeatureList = function () {
                return storage.get('dashboardFeatureList');
            };

            return{
                patientDashboardFeatures: patientDashboardFeatures,
                setDashboardFeatureList: setDashboardFeatureList,
                getDashboardFeatureList: getDashboardFeatureList
            };
    }]);